import template from './template/index.js'
import schema from './schema/index.js'
import pusher from './push/index.js'
import downloadTask from './download-manager/index.js'
import asset from './asset/index.js'
import forbiddenFont from './forbidden-font/index.js'
import detail from './detail/index.ts'
import modelEditor from './model-editor/index.ts'
import modelOrder from './model-order/index.ts'

const creative = {
  namespaced: true,
  modules: {
    template,
    schema,
    pusher,
    downloadTask,
    asset,
    forbiddenFont,
    detail,
    modelEditor,
    modelOrder,
  },
}

export default creative
